import React from 'react';
import styled from '@emotion/styled';
import { themeProp } from '@vmos2/utils';

type Props = {
  name?: string,
  value: number,
  fontSize: string,
  units?: string,
  className?: string,
  lastNutritionItem?: boolean,
};

export const NutritionItem = ({ className, name, value, units, fontSize, lastNutritionItem }: Props) => {
  return (
    <StyledLi fontSize={fontSize} className={className} lastNutritionItem={lastNutritionItem}>
      <Name>{name}</Name>
      <Units>
        {value || '--'}
        {!!value && units}
      </Units>
    </StyledLi>
  );
};

const Name = styled('span')`
  max-width: 81px;

  @media (${themeProp('breakpoint.tablet')}) {
    max-width: unset;
  }
`;

const Units = styled('span')`
  min-width: 51px;
  text-align: right;
`;

const StyledLi = styled('li')`
  display: flex;
  list-style: none;
  justify-content: space-between;
  border-bottom: 1px dotted ${themeProp('color.grey')};
  padding: 4px 0 12px;
  margin: 8px 0 8px;
  font-size: ${themeProp('fontSize.xs')};
  ${({ lastNutritionItem }) => lastNutritionItem && 'border-bottom: none;'}

  @media (${themeProp('breakpoint.tablet')}) {
    font-size: ${({ theme, fontSize }) => theme.fontSize[fontSize]};
  }
`;

NutritionItem.defaultProps = {
  className: null,
  fontSize: 'sm',
};
